import { gql } from '@apollo/client';

//TODO: Still some types to add to this query like StudentSettings
const STUDENT_FRAGMENT = gql`
  fragment BaseStudent on Student {
    id
    username
    firstName
    lastName
    email
    loginType
    password
    gradeLevel
    organizationId
  }
`;

export default STUDENT_FRAGMENT;
